
(function () {
  "use strict";

  console.log("Premium Upsell Dynamic Color Script Loaded");

  /* ============================================================
     COLOR HELPERS
  ============================================================ */

  function hexToRgb(hex) {
    hex = String(hex || "").replace("#", "");

    if (hex.length === 3) {
      hex =
        hex[0] + hex[0] +
        hex[1] + hex[1] +
        hex[2] + hex[2];
    }

    return {
      r: parseInt(hex.substring(0, 2), 16),
      g: parseInt(hex.substring(2, 4), 16),
      b: parseInt(hex.substring(4, 6), 16)
    };
  }

  function rgbToHex(r, g, b) {
    return "#" +
      [r, g, b]
        .map(function (value) {
          return Math.max(
            0,
            Math.min(255, Math.round(value))
          )
            .toString(16)
            .padStart(2, "0");
        })
        .join("");
  }

  function darkenColor(hex, amount) {
    var rgb = hexToRgb(hex);

    return rgbToHex(
      rgb.r * (1 - amount),
      rgb.g * (1 - amount),
      rgb.b * (1 - amount)
    );
  }

  function lightenColor(hex, amount) {
    var rgb = hexToRgb(hex);

    return rgbToHex(
      rgb.r + (255 - rgb.r) * amount,
      rgb.g + (255 - rgb.g) * amount,
      rgb.b + (255 - rgb.b) * amount
    );
  }

  function mixColors(hex1, hex2, ratio) {
    var c1 = hexToRgb(hex1);
    var c2 = hexToRgb(hex2);

    return rgbToHex(
      c1.r * (1 - ratio) + c2.r * ratio,
      c1.g * (1 - ratio) + c2.g * ratio,
      c1.b * (1 - ratio) + c2.b * ratio
    );
  }


  /* ============================================================
     NORMALIZE COLOR NAME
  ============================================================ */

  function normalizeColorName(name) {
    return String(name || "")
      .toLowerCase()
      .trim()
      .replace(/[_\-]+/g, " ")
      .replace(/\s+/g, " ");
  }


  /* ============================================================
     COLOR DATABASE
  ============================================================ */

  var exactColors = {

    /* BLACK */
    "black": "#000000",
    "jet black": "#000000",
    "onyx": "#353839",
    "carbon": "#222222",
    "coal": "#343434",
    "charcoal": "#36454f",
    "ebony": "#262626",
    "ink": "#111111",

    /* WHITE */
    "white": "#ffffff",
    "snow": "#fffafa",
    "ivory": "#fffff0",
    "cream": "#fffdd0",
    "off white": "#faf9f6",
    "off-white": "#faf9f6",
    "pearl": "#f8f6f0",

    /* GREY */
    "grey": "#9b9b9b",
    "gray": "#9b9b9b",
    "light grey": "#d3d3d3",
    "light gray": "#d3d3d3",
    "dark grey": "#555555",
    "dark gray": "#555555",
    "silver": "#c0c0c0",
    "charcoal grey": "#4a4a4a",
    "charcoal gray": "#4a4a4a",

    /* BLUE */
    "blue": "#3f6fb5",
    "navy": "#172554",
    "navy blue": "#172554",
    "dark blue": "#12315b",
    "light blue": "#9fc5e8",
    "sky blue": "#87ceeb",
    "royal blue": "#4169e1",
    "indigo": "#4b0082",
    "midnight blue": "#191970",
    "ocean blue": "#006994",
    "powder blue": "#b0e0e6",
    "denim": "#3f5f8f",
    "dusty blue": "#6f8fa6",
    "soft blue": "#9bb7d4",
    "deep blue": "#12315b",

    /* GREEN */
    "green": "#4f7942",
    "dark green": "#285430",
    "light green": "#90ee90",
    "sage": "#9caf88",
    "sage green": "#9caf88",
    "dark sage": "#6b7d5b",
    "light sage": "#c8d5b9",
    "olive": "#808000",
    "olive green": "#6b8e23",
    "dark olive": "#556b2f",
    "light olive": "#bdb76b",
    "forest green": "#228b22",
    "emerald": "#50c878",
    "mint": "#98ff98",
    "teal": "#008080",
    "dark teal": "#004c4c",
    "light teal": "#80cbc4",
    "moss green": "#8a9a5b",
    "sea green": "#2e8b57",
    "dusty green": "#7f9b82",
    "soft green": "#a8c3a0",

    /* RED */
    "red": "#d93636",
    "dark red": "#8b0000",
    "light red": "#ff7f7f",
    "maroon": "#800000",
    "burgundy": "#800020",
    "wine": "#722f37",
    "wine red": "#722f37",
    "rust": "#b7410e",
    "brick red": "#cb4154",
    "cherry red": "#d2042d",

    /* PINK */
    "pink": "#e8a0ad",
    "light pink": "#ffb6c1",
    "dark pink": "#c2185b",
    "rose": "#d67c8a",
    "dusty rose": "#c08081",
    "blush": "#de8c9a",
    "fuchsia": "#d946ef",
    "magenta": "#d946ef",
    "dusty pink": "#d8a0a6",
    "soft pink": "#f4b6c2",

    /* PURPLE */
    "purple": "#87529a",
    "dark purple": "#4b0082",
    "light purple": "#d8b4fe",
    "violet": "#8f00ff",
    "lavender": "#c4b5d8",
    "mauve": "#b7849b",
    "dark mauve": "#915f6d",
    "light mauve": "#e0b0c0",

    /* ORANGE / CORAL / PEACH */
    "orange": "#d98236",
    "dark orange": "#c45b12",
    "light orange": "#ffb347",
    "coral": "#f0806a",
    "dark coral": "#cd5b45",
    "light coral": "#f7a38b",
    "peach": "#f4b183",
    "light peach": "#ffd1b3",
    "coral peach": "#e99a7c",
    "soft coral": "#eaa08b",

    /* YELLOW */
    "yellow": "#e5c33b",
    "dark yellow": "#b8860b",
    "light yellow": "#fff59d",
    "mustard": "#c9a227",
    "gold": "#d4af37",
    "golden": "#daa520",

    /* BROWN */
    "brown": "#6b4a35",
    "dark brown": "#4a3022",
    "light brown": "#c4a484",
    "chocolate": "#7b3f00",
    "coffee": "#6f4e37",
    "mocha": "#967969",

    /* TAN */
    "tan": "#c9a875",
    "dark tan": "#a67c52",
    "light tan": "#e0c3a0",

    /* BEIGE */
    "beige": "#d8c3a5",
    "dark beige": "#b8a58a",
    "light beige": "#eee5d3",
    "warm beige": "#cdbb9b",
    "cool beige": "#d6cfc3",

    /* EARTH / NEUTRAL */
    "camel": "#c19a6b",
    "nude": "#d8aa88",
    "almond": "#e3d0bb",
    "khaki": "#b8ad87",
    "stone": "#928e85",
    "stone grey": "#8f8f87",
    "stone gray": "#8f8f87",
    "ash": "#b2beb5",
    "ash grey": "#a7aaa7",
    "ash gray": "#a7aaa7",
    "slate": "#708090",
    "slate grey": "#708090",
    "slate gray": "#708090",
    "taupe": "#8b8178",
    "greige": "#b3ada7",
    "sand": "#c2b280",
    "sand beige": "#c2b280",

    /* FASHION / BRAND COLORS */
    "mirage grey": "#aeb4b4",
    "mirage gray": "#aeb4b4",

    "dusty blue": "#6f8fa6",
    "dusty green": "#7f9b82",
    "dusty pink": "#d8a0a6",

    "powder pink": "#f4c2c2",

    "soft pink": "#f4b6c2",
    "soft blue": "#9bb7d4",
    "soft green": "#a8c3a0",

    "dark navy": "#000033",
    "light navy": "#4169e1"
  };


  /* ============================================================
     BASE COLOR MAP
  ============================================================ */

  var baseColorMap = {

    black: "#000000",
    white: "#ffffff",

    navy: "#172554",
    blue: "#3f6fb5",
    indigo: "#4b0082",

    green: "#4f7942",
    olive: "#808000",
    sage: "#9caf88",
    teal: "#008080",

    red: "#d93636",
    maroon: "#800000",
    burgundy: "#800020",
    wine: "#722f37",

    pink: "#e8a0ad",
    rose: "#d67c8a",

    purple: "#87529a",
    violet: "#8f00ff",
    lavender: "#c4b5d8",
    mauve: "#b7849b",

    orange: "#d98236",
    coral: "#f0806a",
    peach: "#f4b183",

    yellow: "#e5c33b",
    mustard: "#c9a227",
    gold: "#d4af37",

    brown: "#6b4a35",
    tan: "#c9a875",
    beige: "#d8c3a5",

    camel: "#c19a6b",
    nude: "#d8aa88",
    almond: "#e3d0bb",
    khaki: "#b8ad87",

    grey: "#9b9b9b",
    gray: "#9b9b9b",
    silver: "#c0c0c0",
    charcoal: "#4a4a4a",

    cream: "#fffdd0",
    ivory: "#fffff0",

    stone: "#928e85",
    taupe: "#8b8178",
    greige: "#b3ada7",
    sand: "#c2b280"
  };


  /* ============================================================
     DYNAMIC COLOR DETECTION
  ============================================================ */

  function getSemanticColor(colorName) {

    var name = normalizeColorName(colorName);

    if (!name) {
      return "#cccccc";
    }

    /* EXACT MATCH */

    if (exactColors[name]) {
      return exactColors[name];
    }


    /* SPECIAL COMBINATION COLORS */

    if (
      name.includes("coral") &&
      name.includes("peach")
    ) {
      return mixColors(
        "#f0806a",
        "#f4b183",
        0.45
      );
    }

    if (
      name.includes("sage") &&
      name.includes("green")
    ) {
      return "#9caf88";
    }

    if (
      name.includes("mirage") &&
      (name.includes("grey") || name.includes("gray"))
    ) {
      return "#aeb4b4";
    }

    if (
      name.includes("dusty") &&
      name.includes("blue")
    ) {
      return "#6f8fa6";
    }

    if (
      name.includes("dusty") &&
      name.includes("green")
    ) {
      return "#7f9b82";
    }

    if (
      name.includes("dusty") &&
      name.includes("pink")
    ) {
      return "#d8a0a6";
    }


    /* WORD MATCHING */

    var words = name.split(/\s+/);

    var baseColor = null;

    for (var i = 0; i < words.length; i++) {

      var word = words[i];

      if (baseColorMap[word]) {
        baseColor = baseColorMap[word];
        break;
      }
    }


    /* PARTIAL MATCHING */

    if (!baseColor) {

      for (var key in baseColorMap) {

        if (name.includes(key)) {
          baseColor = baseColorMap[key];
          break;
        }
      }
    }


    /* UNKNOWN COLOR */

    if (!baseColor) {
      return "#cccccc";
    }


    /* COLOR MODIFIERS */

    var isDark =
      words.includes("dark") ||
      words.includes("deep") ||
      words.includes("darkest");

    var isLight =
      words.includes("light") ||
      words.includes("pale") ||
      words.includes("pastel");

    var isSoft =
      words.includes("soft");

    var isDusty =
      words.includes("dusty");

    var isMuted =
      words.includes("muted");


    if (isDark) {

      return darkenColor(
        baseColor,
        0.25
      );
    }


    if (isLight) {

      return lightenColor(
        baseColor,
        0.35
      );
    }


    if (isSoft) {

      return lightenColor(
        baseColor,
        0.18
      );
    }


    if (isDusty) {

      return mixColors(
        baseColor,
        "#b8aaa0",
        0.25
      );
    }


    if (isMuted) {

      return mixColors(
        baseColor,
        "#a9a9a9",
        0.20
      );
    }


    return baseColor;
  }


  /* ============================================================
     GET ACTUAL COLOR NAME
  ============================================================ */

  function getActualColorName(
    optionElement,
    fallbackName
  ) {

    if (!optionElement) {
      return fallbackName || "";
    }

    var attributes = [
      "data-color",
      "data-colour",
      "data-variant-color",
      "data-color-name",
      "data-swatch-color",
      "aria-label",
      "title"
    ];

    for (var i = 0; i < attributes.length; i++) {

      var value =
        optionElement.getAttribute(
          attributes[i]
        );

      if (
        value &&
        value.trim()
      ) {

        return value.trim();
      }
    }

    return fallbackName || "";
  }


  /* ============================================================
     GET VARIANT IMAGE
  ============================================================ */

  function getVariantImage(optionElement) {

    if (!optionElement) {
      return null;
    }

    var attributes = [
      "data-image",
      "data-variant-img",
      "data-variant-image",
      "data-color-image",
      "data-swatch-image"
    ];

    for (var i = 0; i < attributes.length; i++) {

      var value =
        optionElement.getAttribute(
          attributes[i]
        );

      if (
        value &&
        value.trim()
      ) {

        return value.trim();
      }
    }

    return null;
  }


  /* ============================================================
     GET COLOR FOR VARIANT
  ============================================================ */

  function getColorForVariant(
    optionElement,
    fallbackColorName
  ) {

    var actualColorName =
      getActualColorName(
        optionElement,
        fallbackColorName
      );

    var imgUrl =
      getVariantImage(
        optionElement
      );

    if (imgUrl) {

      return {
        type: "image",
        value: imgUrl,
        name: actualColorName
      };
    }

    return {
      type: "color",
      value: getSemanticColor(
        actualColorName
      ),
      name: actualColorName
    };
  }


  /* ============================================================
     REMOVE QUANTITY ONLY FROM UPSELL PRODUCT
  ============================================================ */

  function removeUpsellQuantityInputs(product) {

    if (!product) {
      return;
    }

    if (
      !product.closest(
        ".upsell-products-block"
      )
    ) {
      return;
    }

    var selectors = [

      'input[type="number"]',

      'input[name*="quantity" i]',

      'input[id*="quantity" i]',

      ".quantity-input",

      ".quantity-selector",

      ".product-quantity",

      ".quantity-wrapper",

      ".quantity-container",

      ".quantity",

      ".product-form__quantity",

      ".quantity__input"
    ];


    selectors.forEach(
      function (selector) {

        product
          .querySelectorAll(selector)
          .forEach(
            function (element) {

              if (
                !element.closest(
                  ".csup-product-row-container"
                )
              ) {
                return;
              }

              if (
                element.closest(
                  ".premium-variant-options"
                )
              ) {
                return;
              }

              element.remove();
            }
          );
      }
    );


    product
      .querySelectorAll(
        ".quantity-wrapper, .quantity-container"
      )
      .forEach(
        function (wrapper) {

          if (
            !wrapper.children.length
          ) {
            wrapper.remove();
          }
        }
      );
  }


  /* ============================================================
     INITIALIZE VARIANT SELECTORS
  ============================================================ */

  function initVariantSelectors() {

    var products =
      document.querySelectorAll(
        ".upsell-products-block .csup-product-row-container"
      );


    if (!products.length) {
      return;
    }


    products.forEach(
      function (product) {

        removeUpsellQuantityInputs(
          product
        );


        if (
          product.querySelector(
            ".premium-variant-options"
          )
        ) {
          return;
        }


        /* FIND ORIGINAL SELECT */

        var select =
          product.querySelector(
            ".product-info-variant-row select"
          );


        if (!select) {

          select =
            product.querySelector(
              "select"
            );
        }


        if (
          !select ||
          !select.options.length
        ) {
          return;
        }


        /* READ VARIANTS */

        var variants = [];


        Array.from(
          select.options
        ).forEach(
          function (option) {

            var text =
              option.textContent.trim();


            if (!text) {
              return;
            }


            var parts =
              text.split("/");


            var color =
              parts[0]
                ? parts[0].trim()
                : "";


            var size =
              parts
                .slice(1)
                .join("/")
                .trim();


            if (
              color &&
              size
            ) {

              variants.push({

                value:
                  option.value,

                color:
                  color,

                size:
                  size,

                text:
                  text,

                option:
                  option
              });
            }
          }
        );


        if (!variants.length) {
          return;
        }


        /* UNIQUE COLORS / SIZES */

        var colors = [];
        var sizes = [];


        variants.forEach(
          function (variant) {

            if (
              !colors.includes(
                variant.color
              )
            ) {

              colors.push(
                variant.color
              );
            }


            if (
              !sizes.includes(
                variant.size
              )
            ) {

              sizes.push(
                variant.size
              );
            }
          }
        );


        if (
          !colors.length ||
          !sizes.length
        ) {
          return;
        }


        /* SELECTED VARIANT */

        var selectedVariant =
          variants.find(
            function (variant) {
              return variant.option.selected;
            }
          ) ||
          variants[0];


        var selectedColor =
          selectedVariant.color;


        var selectedSize =
          selectedVariant.size;


        /* MAIN WRAPPER */

        var wrapper =
          document.createElement(
            "div"
          );

        wrapper.className =
          "premium-variant-options";


        /* COLOR GROUP */

        var colorGroup =
          document.createElement(
            "div"
          );

        colorGroup.className =
          "premium-variant-group";


        var colorHeader =
          document.createElement(
            "div"
          );

        colorHeader.className =
          "premium-variant-header";


        colorHeader.innerHTML =
          "<span>COLOR</span>" +
          '<span class="premium-selected-value">' +
          selectedColor +
          "</span>";


        var colorButtons =
          document.createElement(
            "div"
          );

        colorButtons.className =
          "premium-color-buttons";


        colorGroup.appendChild(
          colorHeader
        );

        colorGroup.appendChild(
          colorButtons
        );


        /* SIZE GROUP */

        var sizeGroup =
          document.createElement(
            "div"
          );

        sizeGroup.className =
          "premium-variant-group";


        var sizeHeader =
          document.createElement(
            "div"
          );

        sizeHeader.className =
          "premium-variant-header";


        sizeHeader.innerHTML =
          "<span>SIZE</span>" +
          '<span class="premium-selected-value">' +
          selectedSize +
          "</span>";


        var sizeButtons =
          document.createElement(
            "div"
          );

        sizeButtons.className =
          "premium-size-buttons";


        sizeGroup.appendChild(
          sizeHeader
        );

        sizeGroup.appendChild(
          sizeButtons
        );


        wrapper.appendChild(
          colorGroup
        );

        wrapper.appendChild(
          sizeGroup
        );


        /* INSERT UI */

        var buttonContainer =
          product.querySelector(
            ".button-container"
          );


        if (buttonContainer) {

          buttonContainer.parentNode.insertBefore(
            wrapper,
            buttonContainer
          );

        } else {

          product.appendChild(
            wrapper
          );
        }


        /* ========================================================
           UPDATE SIZE BUTTONS
        ======================================================== */

        function updateSizeButtons() {

          var buttons =
            sizeButtons.querySelectorAll(
              ".premium-size-button"
            );


          buttons.forEach(
            function (button) {

              var size =
                button.dataset.size;


              var available =
                variants.some(
                  function (variant) {

                    return (
                      variant.color ===
                        selectedColor &&
                      variant.size ===
                        size
                    );
                  }
                );


              button.disabled =
                !available;


              button.classList.toggle(
                "active",
                size === selectedSize &&
                available
              );
            }
          );
        }


        /* ========================================================
           APPLY VARIANT
        ======================================================== */

        function applyVariant() {

          var matchingVariant =
            variants.find(
              function (variant) {

                return (
                  variant.color ===
                    selectedColor &&
                  variant.size ===
                    selectedSize
                );
              }
            );


          if (!matchingVariant) {
            return;
          }


          select.value =
            matchingVariant.value;


          try {

            select.dispatchEvent(
              new Event(
                "change",
                {
                  bubbles: true
                }
              )
            );

          } catch (error) {}


          colorHeader.querySelector(
            ".premium-selected-value"
          ).textContent =
            selectedColor;


          sizeHeader.querySelector(
            ".premium-selected-value"
          ).textContent =
            selectedSize;


          updateSizeButtons();
        }


        /* ========================================================
           CREATE COLOR BUTTONS
        ======================================================== */

        colors.forEach(
          function (color) {

            var variantForColor =
              variants.find(
                function (variant) {

                  return (
                    variant.color ===
                    color
                  );
                }
              );


            if (!variantForColor) {
              return;
            }


            var button =
              document.createElement(
                "button"
              );


            button.type =
              "button";


            button.className =
              "premium-color-button";


            button.dataset.color =
              color;


            var actualColorName =
              getActualColorName(
                variantForColor.option,
                color
              );


            button.dataset.actualColor =
              actualColorName;


            button.setAttribute(
              "aria-label",
              actualColorName
            );


            button.setAttribute(
              "title",
              actualColorName
            );


            var styleData =
              getColorForVariant(
                variantForColor.option,
                actualColorName
              );


            if (
              styleData.type ===
              "image"
            ) {

              button.style.backgroundImage =
                'url("' +
                styleData.value +
                '")';

              button.style.backgroundSize =
                "cover";

              button.style.backgroundPosition =
                "center";

              button.style.backgroundRepeat =
                "no-repeat";

              button.style.backgroundColor =
                "transparent";

            } else {

              button.style.backgroundImage =
                "none";

              button.style.backgroundColor =
                styleData.value;
            }


            if (
              color ===
              selectedColor
            ) {

              button.classList.add(
                "active"
              );
            }


            /* COLOR CLICK */

            button.addEventListener(
              "click",
              function () {

                selectedColor =
                  color;


                var currentCombinationExists =
                  variants.some(
                    function (variant) {

                      return (
                        variant.color ===
                          selectedColor &&
                        variant.size ===
                          selectedSize
                      );
                    }
                  );


                if (
                  !currentCombinationExists
                ) {

                  var firstAvailable =
                    variants.find(
                      function (variant) {

                        return (
                          variant.color ===
                          selectedColor
                        );
                      }
                    );


                  if (firstAvailable) {

                    selectedSize =
                      firstAvailable.size;
                  }
                }


                colorButtons
                  .querySelectorAll(
                    ".premium-color-button"
                  )
                  .forEach(
                    function (item) {

                      item.classList.remove(
                        "active"
                      );
                    }
                  );


                button.classList.add(
                  "active"
                );


                updateSizeButtons();

                applyVariant();
              }
            );


            colorButtons.appendChild(
              button
            );
          }
        );


        /* ========================================================
           CREATE SIZE BUTTONS
        ======================================================== */

        sizes.forEach(
          function (size) {

            var button =
              document.createElement(
                "button"
              );


            button.type =
              "button";


            button.className =
              "premium-size-button";


            button.dataset.size =
              size;


            button.textContent =
              size;


            button.addEventListener(
              "click",
              function () {

                if (
                  button.disabled
                ) {
                  return;
                }


                selectedSize =
                  size;


                updateSizeButtons();

                applyVariant();
              }
            );


            sizeButtons.appendChild(
              button
            );
          }
        );


        /* INITIAL SIZE STATE */

        updateSizeButtons();


        /* HIDE ORIGINAL SELECT */

        select.style.position =
          "absolute";

        select.style.width =
          "1px";

        select.style.height =
          "1px";

        select.style.opacity =
          "0";

        select.style.pointerEvents =
          "none";
      }
    );
  }


  /* ============================================================
     FIND APP CLOSE BUTTON
  ============================================================ */

  function getAppCloseButton() {

    var modal =
      document.querySelector(
        ".push-cart-dialog"
      );

    if (!modal) {
      return null;
    }


    var iconSelectors = [

      ".close-icon",

      ".jumi-close-btn",

      "svg",

      "[aria-label='Close']",

      "[aria-label='close']"
    ];


    for (
      var i = 0;
      i < iconSelectors.length;
      i++
    ) {

      var el =
        modal.querySelector(
          iconSelectors[i]
        );


      if (el) {

        var parentBtn =
          el.closest(
            'button, a, [role="button"], .close-modal, .modal-close'
          );


        if (parentBtn) {
          return parentBtn;
        }


        return el;
      }
    }


    return null;
  }


  /* ============================================================
     TRIGGER FULL CLICK
  ============================================================ */

  function triggerClick(element) {

    if (!element) {
      return;
    }


    ["mousedown", "mouseup", "click"].forEach(
      function (evtType) {

        var event =
          new MouseEvent(
            evtType,
            {
              view: window,
              bubbles: true,
              cancelable: true
            }
          );


        element.dispatchEvent(
          event
        );
      }
    );
  }


  /* ============================================================
     OPEN CART DRAWER
     
     IMPORTANT:
     This does NOT redirect to /cart.
  ============================================================ */

  function openCartDrawer() {

    console.log(
      "Trying to open cart drawer..."
    );


    /* ----------------------------------------------------------
       1. CUSTOM / COMMON CART DRAWER BUTTONS
    ---------------------------------------------------------- */

    var selectors = [

      /* Shopify / Dawn style */
      '[aria-controls="CartDrawer"]',

      '[aria-controls="cart-drawer"]',

      '[aria-controls="CartDrawer-Modal"]',

      '[aria-controls="cart-drawer-modal"]',

      /* Common custom selectors */
      '[data-cart-drawer-trigger]',

      '[data-cart-drawer-toggle]',

      '[data-open-cart-drawer]',

      '.cart-drawer-trigger',

      '.cart-drawer-toggle',

      '.header__icon--cart',

      '.cart-icon-bubble',

      '.cart-link',

      '.cart-button',

      '.site-header__cart',

      '.header-cart',

      '.js-cart-drawer-open',

      '.js-open-cart-drawer'
    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {

      var trigger =
        document.querySelector(
          selectors[i]
        );


      if (
        trigger &&
        !trigger.closest(
          ".upsell-modal-footer"
        )
      ) {

        console.log(
          "Cart drawer trigger found:",
          selectors[i]
        );


        trigger.click();

        return true;
      }
    }


    /* ----------------------------------------------------------
       2. LOOK FOR CART DRAWER ELEMENT ITSELF
    ---------------------------------------------------------- */

    var drawer =
      document.querySelector(
        "#CartDrawer, " +
        "#cart-drawer, " +
        ".cart-drawer, " +
        ".cart-drawer-container, " +
        ".drawer--cart, " +
        "[data-cart-drawer]"
      );


    if (drawer) {

      console.log(
        "Cart drawer element found."
      );


      /* Try common open methods */

      if (
        typeof drawer.open ===
        "function"
      ) {

        drawer.open();

        return true;
      }


      drawer.classList.add(
        "active"
      );

      drawer.classList.add(
        "is-open"
      );

      drawer.classList.add(
        "open"
      );


      drawer.setAttribute(
        "open",
        ""
      );


      drawer.setAttribute(
        "aria-hidden",
        "false"
      );


      return true;
    }


    /* ----------------------------------------------------------
       3. SHOPIFY CART DRAWER COMPONENT
    ---------------------------------------------------------- */

    var cartDrawerComponent =
      document.querySelector(
        "cart-drawer"
      );


    if (cartDrawerComponent) {

      console.log(
        "Shopify cart-drawer component found."
      );


      if (
        typeof cartDrawerComponent.open ===
        "function"
      ) {

        cartDrawerComponent.open();

        return true;
      }


      if (
        typeof cartDrawerComponent.show ===
        "function"
      ) {

        cartDrawerComponent.show();

        return true;
      }
    }


    /* ----------------------------------------------------------
       4. SHOPIFY THEME CART DRAWER API
    ---------------------------------------------------------- */

    if (
      window.Shopify &&
      Shopify.theme &&
      Shopify.theme.cartDrawer &&
      typeof Shopify.theme.cartDrawer.open ===
      "function"
    ) {

      console.log(
        "Using Shopify theme cartDrawer API."
      );


      Shopify.theme.cartDrawer.open();

      return true;
    }


    /* ----------------------------------------------------------
       5. COMMON CUSTOM EVENTS
    ---------------------------------------------------------- */

    try {

      document.dispatchEvent(
        new CustomEvent(
          "cart:open",
          {
            bubbles: true
          }
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          "cart-drawer:open",
          {
            bubbles: true
          }
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          "open-cart-drawer",
          {
            bubbles: true
          }
        )
      );

    } catch (error) {}


    console.warn(
      "Cart drawer trigger/API not found. No redirect was performed."
    );


    return false;
  }


  /* ============================================================
     FOOTER BUTTONS
  ============================================================ */

  function injectFooterButtons() {

    var content =
      document.querySelector(
        ".push-cart-popup-content"
      );


    if (!content) {
      return;
    }


    if (
      content.querySelector(
        ".upsell-modal-footer"
      )
    ) {
      return;
    }


    var footer =
      document.createElement(
        "div"
      );


    footer.className =
      "upsell-modal-footer";


    /* ----------------------------------------------------------
       CLOSE BUTTON
    ---------------------------------------------------------- */

    var btnClose =
      document.createElement(
        "button"
      );


    btnClose.type =
      "button";


    btnClose.className =
      "upsell-footer-btn upsell-btn-close";


    btnClose.textContent =
      "Close";


    /* ----------------------------------------------------------
       GO TO CART BUTTON
       
       BUTTON instead of <a>
       so it cannot navigate to /cart.
    ---------------------------------------------------------- */

    var btnCart =
      document.createElement(
        "button"
      );


    btnCart.type =
      "button";


    btnCart.className =
      "upsell-footer-btn upsell-btn-cart";


    btnCart.textContent =
      "Go to cart";


    btnCart.style.display =
      "flex";


    btnCart.style.alignItems =
      "center";


    btnCart.style.justifyContent =
      "center";


    /* ----------------------------------------------------------
       ADD BUTTONS
    ---------------------------------------------------------- */

    footer.appendChild(
      btnClose
    );

    footer.appendChild(
      btnCart
    );


    content.appendChild(
      footer
    );


    /* ============================================================
       CUSTOM CLOSE BUTTON
    ============================================================ */

    btnClose.addEventListener(
      "click",
      function (e) {

        e.preventDefault();

        e.stopPropagation();


        var appCloseBtn =
          getAppCloseButton();


        if (appCloseBtn) {

          console.log(
            "Closing via App button wrapper..."
          );


          triggerClick(
            appCloseBtn
          );

        } else {

          console.warn(
            "App Close button not found."
          );
        }
      }
    );


    /* ============================================================
       CUSTOM GO TO CART BUTTON
       
       1. Close upsell popup
       2. Wait for cart operation
       3. Open cart drawer
       4. NEVER navigate to /cart
    ============================================================ */

    btnCart.addEventListener(
      "click",
      function (e) {

        e.preventDefault();

        e.stopPropagation();


        console.log(
          "Go to cart clicked."
        );


        var appCloseBtn =
          getAppCloseButton();


        if (appCloseBtn) {

          console.log(
            "Closing upsell popup first..."
          );


          triggerClick(
            appCloseBtn
          );
        }


        /*
         * Wait for the upsell app's
         * add-to-cart/save operation.
         */
        setTimeout(
          function () {

            console.log(
              "Opening cart drawer..."
            );


            openCartDrawer();

          },
          1000
        );
      }
    );
  }


  /* ============================================================
     RUN
  ============================================================ */

  function run() {

    initVariantSelectors();

    injectFooterButtons();


    setTimeout(
      function () {

        initVariantSelectors();

        injectFooterButtons();

      },
      300
    );


    setTimeout(
      function () {

        initVariantSelectors();

        injectFooterButtons();

      },
      800
    );


    setTimeout(
      function () {

        initVariantSelectors();

        injectFooterButtons();

      },
      1500
    );
  }


  /* ============================================================
     DOM READY
  ============================================================ */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      run
    );

  } else {

    run();
  }


  /* ============================================================
     MUTATION OBSERVER
  ============================================================ */

  var observer =
    new MutationObserver(
      function () {

        if (
          document.querySelector(
            ".upsell-products-block"
          )
        ) {

          initVariantSelectors();

          injectFooterButtons();
        }
      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();


/* ==============================================================
   PRODUCT LINK CLICK HANDLER
================================================================ */

(function () {

  "use strict";


  document.addEventListener(
    "click",
    function (event) {

      var clickable =
        event.target.closest(
          ".upsell-products-block .product-image-clickable, " +
          ".upsell-products-block .product-title-clickable, " +
          ".upsell-products-block .product-image img, " +
          ".upsell-products-block .product-title"
        );


      if (!clickable) {
        return;
      }


      var productCard =
        clickable.closest(
          ".csup-product-row-container"
        );


      if (!productCard) {
        return;
      }


      /* Don't interfere with Add to Cart */

      if (
        event.target.closest(
          ".add-to-cart-button"
        )
      ) {
        return;
      }


      /* Don't interfere with color / size */

      if (
        event.target.closest(
          ".premium-variant-options"
        )
      ) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      /* Find actual product URL */

      var productLink =
        productCard.querySelector(
          'a[href*="/products/"]'
        );


      if (productLink) {

        window.location.href =
          productLink.href;

        return;
      }


      /* Fallback: Generate handle */

      var titleElement =
        productCard.querySelector(
          ".product-title"
        );


      if (titleElement) {

        var title =
          titleElement.textContent.trim();


        var handle =
          title
            .toLowerCase()
            .trim()
            .replace(
              /['"]/g,
              ""
            )
            .replace(
              /[^a-z0-9]+/g,
              "-"
            )
            .replace(
              /^-+|-+$/g,
              ""
            );


        if (handle) {

          window.location.href =
            "/products/" +
            handle;
        }
      }

    },
    true
  );

})();

